import React, { useState, useEffect } from "react";
import {
  Main,
  FeaturedProject,
  Timeline,
  Expertise,
  Project,
  Contact,
  Navigation,
  Footer,
} from "./components";
import FadeIn from './components/FadeIn';
import { content, Language } from './data/content';
import './index.scss';

function App() {
  const [lang, setLang] = useState<Language>('pl');

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    document.documentElement.lang = lang;
  }, [lang]);

  const currentContent = content[lang];

  return (
    <div className="main-container light-mode">
      <Navigation
        lang={lang}
        onLangChange={setLang}
        content={currentContent.nav}
      />
      <FadeIn transitionDuration={600}>
        <Main content={currentContent.main} />
        <Expertise content={currentContent.expertise} />
        {currentContent.featured.map((f) => (
          <FeaturedProject key={f.id} content={f} />
        ))}
        <Timeline content={currentContent.timeline} />
        <Project content={currentContent.projects} />
        <Contact
          content={currentContent.contact}
          social={currentContent.main.social}
        />
      </FadeIn>
      <Footer
        content={currentContent.footer}
        social={currentContent.main.social}
      />
    </div>
  );
}

export default App;